/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Quote_5_TextInputs */

const da_forside_quote_5_text = /** @type {(inputs: Forside_Quote_5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Som afdelingsleder ser jeg potentialet i, at lærerne retter mere ensartet på tværs af klasser – og får tid tilbage til undervisningen.`)
};

/** @type {(inputs: Forside_Quote_5_TextInputs) => LocalizedString} */
const en_forside_quote_5_text = da_forside_quote_5_text;

/**

* @param {Forside_Quote_5_TextInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_quote_5_text = /** @type {((inputs?: Forside_Quote_5_TextInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Quote_5_TextInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_quote_5_text(inputs)
	return /** @type {LocalizedString} */ ("Som afdelingsleder ser jeg potentialet i, at lærerne retter mere ensartet på tværs af klasser – og får tid tilbage til undervisningen.")
});